import React from "react";
import PropTypes from "prop-types";

class Expandable extends React.Component {
  static propTypes = {
    defaultIsExpanded: PropTypes.bool,
    expandableClassName: PropTypes.string
  };

  static defaultProps = {
    defaultIsExpanded: false,
    expandableClassName: ""
  };

  constructor(props) {
    super(props);
    this._element = React.createRef();
    this.state = { isExpanded: props.defaultIsExpanded };
    this.toggleExpand = this.toggleExpand.bind(this);
  }

  toggleExpand() {
    // eslint-disable-next-line react/no-access-state-in-setstate
    this.setState({ isExpanded: !this.state.isExpanded });
  }

  render() {
    /* eslint-disable jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events */
    return (
      <div
        className={this.props.expandableClassName}
        ref={this._element}
        onClick={this.toggleExpand}
        data-is-expanded={this.state.isExpanded}
      >
        {React.cloneElement(this.props.children, {
          isExpanded: this.state.isExpanded
        })}
      </div>
    );
    /* eslint-enable jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events */
  }
}

export default Expandable;
